module.exports = __webpack_public_path__ + "img/jinengjingsai.bd876677.png";